import { render } from "./SidebarMenu.vue?vue&type=template&id=de0dc48e&scoped=true"
import script from "./SidebarMenu.vue?vue&type=script&lang=js"
export * from "./SidebarMenu.vue?vue&type=script&lang=js"

import "./SidebarMenu.vue?vue&type=style&index=0&id=de0dc48e&scoped=true&lang=css"
import "./SidebarMenu.vue?vue&type=style&index=1&id=de0dc48e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de0dc48e"],['__file',"src/layouts/sidebar/SidebarMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "de0dc48e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('de0dc48e', __exports__)) {
    api.reload('de0dc48e', __exports__)
  }
  
  module.hot.accept("./SidebarMenu.vue?vue&type=template&id=de0dc48e&scoped=true", () => {
    api.rerender('de0dc48e', render)
  })

}


export default __exports__